import { render, staticRenderFns } from "./ubruCoffeeRetrunView.vue?vue&type=template&id=15cf4f72"
import script from "./ubruCoffeeRetrunView.vue?vue&type=script&lang=js"
export * from "./ubruCoffeeRetrunView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports